import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { DepositsService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class DepositBloc extends Bloc<DepositsService['depositControllerGetOne']> {
    public constructor(service: DepositsService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.depositControllerGetOne.bind(service), {
            debug: debug ?? false,
        });
    }
}
